import { ChangeEventHandler, LegacyRef } from "react";
import { PaperClipIcon, XIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

type ChatMessageBoxProps = {
  onMessageChange: (value: string) => void;
  onSendDraftMessage: () => void;
  onSelectFile: (file: File | undefined) => void;
  draftMessage?: string;
  selectedFile?: File;
  enableAttachment?: boolean;
  messageBoxInputRef: LegacyRef<HTMLTextAreaElement>;
};

export default function ChatMessageBox(props: ChatMessageBoxProps) {
  const {
    onMessageChange,
    onSelectFile,
    onSendDraftMessage,
    draftMessage,
    selectedFile,
    enableAttachment = false,
    messageBoxInputRef
  } = props;
  const LocalBasePath = "page.chat";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });

  const onValueChange: ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    onMessageChange(e.target.value);
  };
  const onFileChange: ChangeEventHandler<HTMLInputElement> = (e) => {};
  const onResetFile = () => {};

  return (
    <div className="w-full focus-within:ring-1 focus-within:ring-gray-200 bg-gray-50 md:rounded-md shadow-inner ">
      <div className="w-full px-8 py-4 ">
        <form>
          <div>
            <textarea
              rows={3}
              name="comment"
              id="messaging-box"
              className="block text-gray-900 w-full focus:outline-none focus:ring-0  bg-transparent   resize-none border-none  text-sm"
              placeholder={t("writeMessages")}
              value={draftMessage}
              defaultValue={draftMessage}
              onChange={onValueChange}
              ref={messageBoxInputRef}
            />
          </div>
          <div
            className={`flex pt-[6px] border-t border-gray-100 ${
              enableAttachment ? "justify-between" : "justify-end"
            }`}
          >
            {enableAttachment && (
              <div className="flex items-center space-x-5">
                <div className=" flex items-center gap-3  text-xs leading-5 font-medium text-gray-400">
                  <label
                    htmlFor="file-upload"
                    className=" cursor-pointer   text-xs leading-5 font-medium text-gray-400"
                  >
                    <PaperClipIcon className="h-6 w-6" aria-hidden="true" />

                    <input
                      id="file-upload"
                      onChange={onFileChange}
                      accept="image/*"
                      type="file"
                      className="hidden"
                    />
                  </label>
                  <p className="truncate w-28">
                    {!!selectedFile ? selectedFile.name : t("sendFile")}
                  </p>
                  {!!selectedFile && (
                    <button
                      className="border-none bg-transparent  "
                      onClick={onResetFile}
                    >
                      <XIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  )}
                </div>
              </div>
            )}
            <div className="flex-shrink-0">
              <button
                type="button"
                className="inline-flex items-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium text-white shadow-sm  bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-600"
                onClick={onSendDraftMessage}
              >
                {t("send")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
